import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileSticky from "../components/MobileSticky";
import BeforeAfterSlider from "../components/BeforeAfterSlider";
import Seo from "../components/Seo";
import { api, fullUrl } from "../lib/api";
import { GALLERY, SERVICES } from "../data/site";

export default function Gallery() {
  const [items, setItems] = useState(GALLERY);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    api.get("/gallery").then(({ data }) => {
      if (data?.length) {
        const remote = data.map((d) => ({
          id: d.id,
          title: d.title,
          suburb: d.suburb || "",
          service: d.service || "",
          before: fullUrl(d.before_url),
          after: fullUrl(d.after_url),
        }));
        setItems([...remote, ...GALLERY]);
      }
    }).catch(() => {});
  }, []);

  const filters = ["All", ...SERVICES.map((s) => s.name)];
  const filtered = filter === "All" ? items : items.filter((i) => i.service === filter);

  return (
    <div data-testid="page-gallery">
      <Seo
        title="Gallery — Before & After Painting Projects | Connolly's Painting Solutions"
        description="Browse our before-and-after gallery of Sunshine Coast painting projects — interior, exterior, roof and specialty finishes."
        path="/gallery"
      />
      <Header />

      <section className="section bg-[#F9F8F6]">
        <div className="container-cps">
          <div className="overline">Our work</div>
          <h1 className="font-display text-5xl md:text-7xl mt-4 tracking-tight">Before. After.</h1>
          <p className="mt-6 text-[#4F5B6A] max-w-2xl">Drag the slider on any project to see the transformation. Click any project to start a quote for similar work.</p>

          <div className="mt-12 flex flex-wrap gap-2" role="tablist">
            {filters.map((f) => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                className={`px-5 py-2 text-xs uppercase tracking-[0.18em] border ${filter === f ? "bg-[#0B1426] text-white border-[#0B1426]" : "bg-transparent text-[#0B1426] border-[#0B1426]/30 hover:border-[#0B1426]"}`}
                data-testid={`gallery-filter-${f.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {f}
              </button>
            ))}
          </div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-1">
            {filtered.map((g, i) => (
              <div key={g.id} className="bg-white">
                <BeforeAfterSlider before={g.before} after={g.after} testId={`gallery-ba-${i}`} />
                <div className="p-6 flex items-center justify-between">
                  <div>
                    <p className="font-display text-xl text-[#0B1426]">{g.title}</p>
                    <span className="text-xs uppercase tracking-wider text-[#4F5B6A]">{g.suburb} · {g.service}</span>
                  </div>
                  <Link to="/quote" className="text-xs uppercase tracking-[0.18em] text-[#C5A059] hover:text-[#0B1426]" data-testid={`gallery-quote-${i}`}>
                    Get similar →
                  </Link>
                </div>
              </div>
            ))}
            {filtered.length === 0 && (
              <p className="text-[#4F5B6A]">No projects match that filter yet — check back soon.</p>
            )}
          </div>
        </div>
      </section>

      <Footer />
      <MobileSticky />
    </div>
  );
}
